import {
  CREATE_USER_SERVICE_REQUEST_FAIL,
  CREATE_USER_SERVICE_REQUEST_REQUEST,
  CREATE_USER_SERVICE_REQUEST_SUCCESS,
  DELETE_USER_SERVICE_REQUEST_FAIL,
  DELETE_USER_SERVICE_REQUEST_REQUEST,
  DELETE_USER_SERVICE_REQUEST_SUCCESS,
  GET_USER_SERVICE_REQUEST_FAIL,
  GET_USER_SERVICE_REQUEST_REQUEST,
  GET_USER_SERVICE_REQUEST_SUCCESS,
} from "../../types/user/serviceRequestTypes";

export const createUserServiceRequestReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_USER_SERVICE_REQUEST_REQUEST:
      return {
        ...state,
        createUserServiceRequestLoading: true,
      };
    case CREATE_USER_SERVICE_REQUEST_SUCCESS:
      return {
        ...state,
        createUserServiceRequestLoading: false,
        createUserServiceRequestInfo: payload,
        createUserServiceRequestErrors: "",
      };
    case CREATE_USER_SERVICE_REQUEST_FAIL:
      return {
        ...state,
        createUserServiceRequestLoading: false,
        createUserServiceRequestErrors: payload,
        createUserServiceRequestInfo: [],
      };
    default:
      return state;
  }
};

export const deleteUserServiceRequestReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_USER_SERVICE_REQUEST_REQUEST:
      return {
        ...state,
        deleteUserServiceRequestLoading: true,
      };
    case DELETE_USER_SERVICE_REQUEST_SUCCESS:
      return {
        ...state,
        deleteUserServiceRequestLoading: false,
        deleteUserServiceRequestInfo: payload,
        deleteUserServiceRequestErrors: "",
      };
    case DELETE_USER_SERVICE_REQUEST_FAIL:
      return {
        ...state,
        deleteUserServiceRequestLoading: false,
        deleteUserServiceRequestErrors: payload,
        deleteUserServiceRequestInfo: [],
      };
    default:
      return state;
  }
};

export const getUserServiceRequestReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_SERVICE_REQUEST_REQUEST:
      return {
        ...state,
        getUserServiceRequestLoading: true,
      };
    case GET_USER_SERVICE_REQUEST_SUCCESS:
      return {
        ...state,
        getUserServiceRequestLoading: false,
        getUserServiceRequestInfo: payload,
        getUserServiceRequestErrors: "",
      };
    case GET_USER_SERVICE_REQUEST_FAIL:
      return {
        ...state,
        getUserServiceRequestLoading: false,
        getUserServiceRequestErrors: payload,
        getUserServiceRequestInfo: [],
      };
    default:
      return state;
  }
};
